module.exports = __webpack_public_path__ + "img/blog_icon.a0a8b1f0.svg";